import React from 'react'
import { Accordion, AccordionWrapper } from '../seo-content/seo_content'
import { withAppContext } from 'src/store/initAppContext'
import SlotGameSEOFun88 from './SlotGameSEOFun88'
import SlotGameSEOYolo from './SlotGameSEOYolo'
import { getDamain } from 'src/util/commonfun'
import SlotGameSEO61 from './SlotGameSEO61'
import SlotGameSEO33 from './SlotGameSEO33'

type Props = {

}

const SlotGameSEO = (props: any) => {

  const { app: { brandId } } = props;
  let domainURL = getDamain(brandId);

  return (
    (brandId === 40 || brandId === 46) ? <></> :
    (brandId === 31 || brandId === 32) ? <SlotGameSEOYolo /> :
    (brandId === 47) ? <SlotGameSEOFun88 /> :
    (brandId === 61) ? <SlotGameSEO61 /> :
    (brandId === 33) ? <SlotGameSEO33 /> :
    <SlotGameSEOYolo />
  )
}

export default withAppContext(SlotGameSEO);